import { useEffect, useState } from "react";
import { useAppSelector } from "slice";
import { useGetUserPhotosQuery } from "slice/user";

export const usePhotosAndVideos = () => {
    const {
        data: { id: user_id },
    } = useAppSelector((state) => state.model);
    const { data, refetch } = useGetUserPhotosQuery(user_id, {
        refetchOnMountOrArgChange: true,
    });

    const [portfolioImages, setPortfolioImages] = useState<Image[]>([]);

    useEffect(() => {
        if (data && data.length > 0) {
            const portfolio =
                data.filter(
                    (image: Image) => image.image_type === "portfolio"
                ) || {};

            setPortfolioImages(portfolio);
        } else {
            setPortfolioImages([]);
        }
    }, [data, refetch]);

    const handleError = () => {
        refetch();
    };

    return {
        portfolioImages,
        handleError,
    };
};
